import React from 'react'

import WIZARD_FINISH_IMAGE from '@public/assets/welcome-wizard/welcome-complete.png'

const WelcomeCompleteStep = () => (
  <div className="max-w-[900px]">
    <h2 className="text-lg font-semibold text-black">
      Start recovering billable time today
    </h2>
    <p className="mt-3 text-base leading-[1.35] text-[#666]">
      You&apos;re now familiar with the basics of MIRA. If you need help, you
      may use the in-app chat in the side menu or contact{' '}
      <a
        className="text-[#6545e8] hover:underline"
        href="mailto:support@matteroom.com"
      >
        support@matteroom.com
      </a>
      .
    </p>
    <img
      alt="Person getting work done with MIRA"
      className="mx-auto mt-4 h-[260px] w-[450px] object-contain"
      src={WIZARD_FINISH_IMAGE}
    />
  </div>
)

export default WelcomeCompleteStep
